<template>
  <div id="wrap">
    <Header/>
    <Scroll/>
    <div class="hp_productWrap">
      <div class="hp_productDetail_topWrap">
        <!-- 슬라이드 이미지 및 기본 정보 -->
        <swiper :options="statusData.travelProductSwiperOptions" class="hp_productDetail_mainSlider">
          <swiper-slide class="hp_productDetail_mainSlider_imgBox" v-for="(img, index) in statusData.travelImages" :key="index">
            <img :src="img" :alt="'Image' + (index + 1)" v-if="img"/>
          </swiper-slide>
          <div class="travel_product_detail_swiper_prev" slot="button-prev"></div>
          <div class="travel_product_detail_swiper_next" slot="button-next"></div>
        </swiper>
        <div class="hp_productDetail_topInfo" v-if="statusData.travelProduct.length !== 0">
          <div class="hp_productMain_listInfo_tags">
            <span v-for="tag in JSON.parse(statusData.travelProduct.travel_product_tag)" :key="tag">
              <a :href="`/TravelProduct?travelSearchData=${encodeURIComponent(tag)}`">{{ tag }}</a>
            </span>
          </div>
          <p class="hp_productMain_listInfo_infoTit">
            {{ statusData.travelProduct.travel_product_name }}
          </p>

          <ul class="hp_productDetail_subInfo">
            <li>
              <p>· 여행기간</p>
              <span class="hp_productDetail_RedColor" v-if="statusData.travelProduct.travel_product_night === 0">당일</span>
              <span class="hp_productDetail_RedColor" v-else>{{ statusData.travelProduct.travel_product_night }}박 {{ statusData.travelProduct.travel_product_day }}일</span>
            </li>
            <li v-if="statusData.travelProduct.travel_product_point !== 0">
              <p>· 적립포인트</p>
              <span>{{ statusData.travelProduct.travel_product_point.toLocaleString() }} Point (예약 1건당 1회 적립)</span>
            </li>
            <li>
              <p>· 최소출발인원</p>
              <span>{{ statusData.travelProduct.travel_product_minimum_departure }}명</span>
            </li>
            <li>
              <p>· 모이는장소</p>
              <span>{{ statusData.travelProduct.travel_product_gather_place }}</span>
            </li>
          </ul>
          <div class="hp_productDetail_listInfo_prePrice">
            <ul v-if="statusData.travelProduct.schedule_price_min !== 0 && statusData.travelProduct.schedule_price_child_min !== 0">
              <li>
                <p>대인</p>{{ statusData.travelProduct.schedule_price_min.toLocaleString() }}<span>원~</span>
              </li>
              <li v-if="statusData.travelProduct.schedule_price_child_min !== 0">
                <p>소인</p>{{ statusData.travelProduct.schedule_price_child_min.toLocaleString() }}<span>원~</span>
              </li>
            </ul>
            <div>(1인 기준요금)</div>
          </div>
          <div class="hp_productDetail_topBtns">
            <button @click="handleWishlist"><em></em> 관심여행 등록하기</button>
            <button @click="togglePopup">공유하기</button>
            <button @click="handlePrint">인쇄하기</button>
          </div>
        </div>
      </div>

      <div class="hp_productDetail_btWrap">
        <!-- 상세 설명 및 예약 정보 -->
        <div class="hp_productDetail_btWrap_left">
          <div class="hp_productDetail_btWrap_travelInfo">
            <div class="hp_productDetail_btWrap_travelInfo_tit pcView_displayNone">여행정보</div>
            <ul>
              <li>
                <p><img src="../../../assets/images/icon/icon_pd_course.png" alt="여행코스"/>여행코스</p>
                <p>{{ statusData.travelProduct.travel_product_travel_cource }}</p>
              </li>
              <li>
                <p><img src="../../../assets/images/icon/icon_pd_include.png" alt="포함내역"/>포함내역</p>
                <p>{{ statusData.travelProduct.travel_product_included }}</p>
              </li>
              <li>
                <p><img src="../../../assets/images/icon/icon_pd_includeex.png" alt="불포함내역"/>불포함내역</p>
                <p>{{ statusData.travelProduct.travel_product_included_not }}</p>
              </li>
              <li>
                <p><img src="../../../assets/images/icon/icon_pd_info.png" alt="안내사항"/>안내사항</p>
                <p>{{ statusData.travelProduct.travel_product_info }}</p>
              </li>
            </ul>
          </div>

          <div class="hp_productDetail_btWrap_calendarBody">
            <div class="hp_productDetail_btWrap_calendarBody_titBox">
              <div>출발일선택 &amp; 예약하기</div>
              <div>
                <p>출발확정</p>
                <p>예약가능</p>
                <p>예약마감</p>
              </div>
            </div>
            <div class="hp_productDetail_btWrap_calendarWrap">
              <div class="hp_productDetail_btWrap_calendarBox">
                <div class="hp_productDetail_btWrap_calendarHeader">
                  <button @click="prevMonth" class="calendarHeader_btnPrev">이전달</button>
                  <span>{{ formatDate(statusData.currentDate, 'YYYY.MM') }}</span>
                  <button @click="nextMonth" class="calendarHeader_btnPrevNext">다음달</button>
                </div>
                <div class="hp_productDetail_btWrap_calendarBody">
                  <div class="hp_productDetail_btWrap_calendarDay">
                    <div v-for="day in statusData.dayNames" :key="day">{{ day }}</div>
                  </div>
                  <div class="hp_productDetail_btWrap_calendarDates">
                    <div v-for="(date, index) in getCalendarDates(statusData.currentDate)" :key="index" class="datesItem" @click="handleDateClick(date)">
                      <span :class="date.info ? date.info.color_class_name : ''">{{ date.day }}</span>
                      <div v-if="date.info" class="datesInfo">
                        <div>{{ date.info.status }}</div>
                        <div :class="date.info ? date.info.color_class_name : ''">{{ date.info.detail }}</div>
                      </div>
                      <em :class="date.info ? date.info.color_class_name : ''"></em>
                    </div>
                  </div>
                </div>
              </div>
              <div class="hp_productDetail_btWrap_calendarBox calendarNextmonth">
                <div class="hp_productDetail_btWrap_calendarHeader">
                  <span>{{ formatDate(statusData.nextDate, 'YYYY.MM') }}</span>
                  <button @click="nextMonth" class="calendarHeader_btnNext">다음달</button>
                </div>
                <div class="hp_productDetail_btWrap_calendarBody">
                  <div class="hp_productDetail_btWrap_calendarDay">
                    <div v-for="day in statusData.dayNames" :key="day">{{ day }}</div>
                  </div>
                  <div class="hp_productDetail_btWrap_calendarDates">
                    <div v-for="(date, index) in getCalendarDates(statusData.nextDate)" :key="index" class="datesItem" @click="handleDateClick(date)">
                      <span :class="date.info ? date.info.color_class_name : ''">{{ date.day }}</span>
                      <div v-if="date.info" class="datesInfo">
                        <div>{{ date.info.status }}</div>
                        <div :class="date.info ? date.info.color_class_name : ''">{{ date.info.detail }}</div>
                      </div>
                      <em :class="date.info ? date.info.color_class_name : ''"></em>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="hp_productDetail_btWrap_clickWrap">
          <div v-if="statusData.clickDate === ''" class="clickWrap_0ffPrice">
            <p>달력에서 날짜를 선택하면<br> 여행 요금을 확인할 수 있습니다.</p>
          </div>

          <!-- 옵션 A : 인원 선택 -->
          <div v-if="statusData.clickDate !== '' && statusData.clickScheduleOptionUseStatus === 2">
            <div class="clickWrap_onPrice">
              <ul>
                <li>출발일</li>
                <li class="clickWrap_onPriceDate">{{statusData.clickDate}}</li>
              </ul>
              <ul>
                <li>예약가능좌석</li>
                <li>{{statusData.totalSeats}}명</li>
              </ul>
              <ul>
                <li>
                  대인 선택
                  <p class="clickWrap_onPriceEachPrice">
                    ({{statusData.scheduleSeats.schedule_price.toLocaleString()}}<span>원</span>)
                  </p>
                </li>
                <li>
                  <select v-model="statusData.selectedAdults" @change="updateSelection('adults')">
                    <option value="0">선택해주세요.</option>
                    <option :key="n" v-for="n in availableAdultSeats(statusData.totalSeats)" :value="n">대인 {{ n }}명</option>
                  </select>
                </li>
              </ul>
              <ul>
                <li>
                  소인 선택
                  <p class="clickWrap_onPriceEachPrice">
                    ({{statusData.scheduleSeats.schedule_price_child.toLocaleString()}}<span>원</span>)
                  </p>
                </li>
                <li>
                  <select v-model="statusData.selectedChildren" @change="updateSelection('children')">
                    <option value="0">선택해주세요.</option>
                    <option :key="n" v-for="n in availableChildSeats(statusData.totalSeats, statusData.selectedAdults)" :value="n">소인 {{ n }}명</option>
                  </select>
                </li>
              </ul>
              <div class="clickWrap_totalPrice">
                <p>· 총 예상결제금액</p>
                <p><span>{{statusData.totalPrice.toLocaleString()}}</span> 원</p>
              </div>
            </div>
          </div>

          <!-- 옵션 B : 타입 2개 선택, 인원 선택 / 옵션 B, C 묶여있음 -->
          <div v-if="statusData.clickDate !== '' && statusData.clickScheduleOptionUseStatus === 1" class="clickWrap_onPrice">
            <ul>
              <li>출발일</li>
              <li class="clickWrap_onPriceDate">{{statusData.clickDate}}</li>
            </ul>
            <div v-if="statusData.scheduleGroupOptionRows.length > 0">
              <div v-for="(group, index) in statusData.groups" :key="index">
                <ul class="clickWrap_onPriceShow">
                  <li>{{ statusData.clickScheduleGroupOptionTitle }}</li>
                  <li>
                    <select v-model="group.selectedGroupOption" @change="resetOptions(group)">
                      <option value="0">선택해주세요.</option>
                      <option v-for="groupOption in statusData.scheduleGroupOptionRows" :key="groupOption.schedule_group_option_ID" :value="groupOption.schedule_group_option_ID">
                        {{ groupOption.schedule_group_option_name }}
                      </option>
                    </select>
                  </li>
                </ul>
                <div v-if="group.selectedGroupOption !== 0" v-for="option in filteredGroupOptions(group)" :key="option.schedule_option_ID">
                  <ul>
                    <li>{{ option.schedule_option_name }}</li>
                    <li>
                      <select v-model="group.selectedOptionList" @change="updateSelectedOptionDetails(group)">
                        <option value="0">선택해주세요.</option>
                        <option v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID" :value="list.schedule_option_list_ID">
                          {{ list.schedule_option_list_name }}
                        </option>
                      </select>
                    </li>
                  </ul>
                </div>
                <div v-if="group.selectedOptionList !== 0">
                  <ul>
                    <li>예약 가능 좌석</li>
                    <li>{{ availableSeats(group.selectedOptionList) }}명</li>
                  </ul>
                  <ul>
                    <li>
                      대인 선택
                      <p class="clickWrap_onPriceEachPrice">
                        <span>({{ group.selectedOptionDetails.schedule_option_list_price.toLocaleString() }}</span>원)
                      </p>
                    </li>
                    <li>
                      <select v-model="group.selectedAdults" @change="updateSelectionOption('adults', group, group.selectedOptionList)">
                        <option value="0">선택해주세요.</option>
                        <option :key="n" v-for="n in availableAdultSeats(group.availableSeats)" :value="n">{{ n }}명</option>
                      </select>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      소인 선택
                      <p class="clickWrap_onPriceEachPrice">
                        <span>({{ group.selectedOptionDetails.schedule_option_list_price_child.toLocaleString() }}</span>원)
                      </p>
                    </li>
                    <li>
                      <select v-model="group.selectedChildren" @change="updateSelectionOption('children', group, group.selectedOptionList)">
                        <option value="0">선택해주세요.</option>
                        <option :key="n" v-for="n in availableChildSeats(group.availableSeats, group.selectedAdults)" :value="n">{{ n }}명</option>
                      </select>
                    </li>
                  </ul>
                  <!-- 해밀사에 개별 합계없어서 주석처리함
                  <ul>
                    <li>총 예상 결제금액</li>
                    <li v-if="group.totalPriceValid">{{ totalPriceGroup(group).toLocaleString() }}원</li>
                    <li v-else>예약인원을 맞춰주세요</li>
                  </ul> -->
                </div>
              </div>
              <div class="clickWrap_addBtns">
                <button class="clickWrap_addBtnsMinus" @click="removeGroup(index)">-</button>
                <button class="clickWrap_addBtnsPlus" @click="addGroup()">+</button>
              </div>
              <div class="clickWrap_totalPrice">
                <p>· 총 예상결제금액</p>
                <p><span>{{ totalGroupPrice() }}</span></p>
              </div>
            </div>

            <!-- 옵션 C : 타입 1개 선택, 인원 선택 -->
            <div v-else>
              <div v-for="(group, index) in statusData.groups" :key="index">
                <div v-for="option in statusData.scheduleOptionRows" :key="option.schedule_option_ID">
                  <ul class="clickWrap_onPriceShow">
                    <li>
                      {{ option.schedule_option_name }}
                    </li>
                    <li>
                      <select v-model="group.selectedOptionList" @change="updateSelectedOptionDetails(group)">
                        <option value="0">선택해주세요.</option>
                        <option v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID" :value="list.schedule_option_list_ID">
                            {{ list.schedule_option_list_name }}
                        </option>
                      </select>
                    </li>
                  </ul>
                </div>
                <div v-if="group.selectedOptionList !== 0">
                  <ul>
                    <li>예약 가능 좌석</li>
                    <li>{{ availableSeats(group.selectedOptionList) }}명</li>
                  </ul>
                  <ul>
                    <li>
                      대인 선택
                       <p class="clickWrap_onPriceEachPrice">
                        <span>({{ group.selectedOptionDetails.schedule_option_list_price.toLocaleString() }}</span>원
                       </p>
                    </li>
                    <li>
                      <select v-model="group.selectedAdults" @change="updateSelectionOption('adults', group, group.selectedOptionList)">
                          <option value="0">선택해주세요.</option>
                          <option :key="n" v-for="n in availableAdultSeats(group.availableSeats)" :value="n">{{ n }}명</option>
                      </select>
                    </li>
                  </ul>
                  <ul>
                    <li>
                      소인 선택
                      <p class="clickWrap_onPriceEachPrice">
                        <span>({{ group.selectedOptionDetails.schedule_option_list_price_child.toLocaleString() }}원)</span>
                      </p>
                    </li>
                    <li>
                      <select v-model="group.selectedChildren" @change="updateSelectionOption('children', group, group.selectedOptionList)">
                        <option value="0">선택해주세요.</option>
                        <option :key="n" v-for="n in availableChildSeats(group.availableSeats, group.selectedAdults)" :value="n">{{ n }}명</option>
                      </select>
                    </li>
                  </ul>
                 <!-- 해밀사에 개별 합계없어서 주석처리함
                  <ul>
                    <li>총 예상 결제금액</li>
                    <li v-if="group.totalPriceValid">{{ totalPriceGroup(group).toLocaleString() }}원</li>
                    <li v-else>예약인원을 맞춰주세요</li>
                  </ul> -->
                </div>
              </div>
              <div class="clickWrap_addBtns">
                <button class="clickWrap_addBtnsMinus" @click="removeGroup(index)">-</button>
                <button class="clickWrap_addBtnsPlus" @click="addGroupWithoutOption()">+</button>
              </div>
              <div class="clickWrap_totalPrice">
                <p>· 총 예상결제금액</p>
                <p><span>{{ totalGroupPrice() }}</span></p>
              </div>
            </div>
          </div>
          <div v-if="statusData.clickDate !== ''" class="clickWrap_reservationBtn">
            <button @click="handleReservation">{{statusData.clickDate}} 예약하기</button>
          </div>
        </div>
      </div>

      <div class="hp_productDetail_btWrap_tabBody">
        <!-- 탭 타이틀 영역 -->
        <ul class="hp_productDetail_btWrap_tabWrap">
          <li @click="statusData.activeTab = 'itinerary'" :class="{ tabOnColor: statusData.activeTab === 'itinerary' }">여행일정표</li>
          <li @click="statusData.activeTab = 'fare'" :class="{ tabOnColor: statusData.activeTab === 'fare' }">여행요금안내</li>
          <li @click="statusData.activeTab = 'guide'" :class="{ tabOnColor: statusData.activeTab === 'guide' }">이용안내</li>
          <li @click="statusData.activeTab = 'refund'" :class="{ tabOnColor: statusData.activeTab === 'refund' }">취소/환불규정</li>
        </ul>
        <!-- 탭 : 여행일정표 -->
        <div v-for="schedule in statusData.travelScheduleTimes" :key="schedule.schedule_time_ID" class="hp_tabWrap_scheduleWrap" v-if="statusData.activeTab === 'itinerary'">
          <div class="hp_tabWrap_scheduleTit">
            <h3>{{ schedule.schedule_time_title }}</h3>
          </div>
          <div class="scheduleWrap_schedulMealBed">
            <div class="scheduleWrap_scheduleMeal">
              <h4>식사</h4>
              <ul>
                <li v-if="schedule.schedule_time_breakfast">
                  <p class="scheduleWrap_scheduleMealTit">조식</p> <p class="scheduleWrap_scheduleMealInfo">{{ schedule.schedule_time_breakfast }}</p>
                </li>
                <li v-if="schedule.schedule_time_lunch">
                  <p class="scheduleWrap_scheduleMealTit">중식</p> <p class="scheduleWrap_scheduleMealInfo">{{ schedule.schedule_time_lunch }}</p>
                </li>
                <li v-if="schedule.schedule_time_dinner">
                  <p class="scheduleWrap_scheduleMealTit">석식</p> <p class="scheduleWrap_scheduleMealInfo">{{ schedule.schedule_time_dinner }}</p>
                </li>
              </ul>
            </div>
            <div class="scheduleWrap_scheduleBed">
              <h4>숙소</h4>
              <div v-if="schedule.schedule_time_lodging">
                {{ schedule.schedule_time_lodging }}
              </div>
            </div>
          </div>
          <!-- 탭 : 여행일정표 - 세부일정 -->
          <div v-for="detail in statusData.travelScheduleDetailTimes.filter(d => d.schedule_time_ID_use_schedule_detail_time === schedule.schedule_time_ID)" :key="detail.schedule_detail_time_ID"
           class="scheduleWrap_scheduleDetail">
            <div class="scheduleWrap_scheduleDetailBox">
              <p class="scheduleDetail_timeTit">{{ detail.schedule_detail_time_title }}</p>
              <p class="scheduleDetail_time">{{ detail.schedule_detail_time }}</p>
              <div class="scheduleDetail_contentWrap">
                <div class="scheduleDetail_content" v-editor-html="detail.schedule_detail_time_content"></div>
                <div v-if="detail.shcedule_detail_time_toggle_status === 1" class="scheduleDetail_toggleBox"> <!-- 토글 목록 -->
                  <button @click="toggleVisibility(detail)">{{ detail.isVisible ? '- 닫기' : '+ 자세히 보기' }}</button>
                  <div v-if="detail.isVisible" v-editor-html="detail.shcedule_detail_time_toggle_content" class="scheduleDetail_toggleContent"></div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 탭 : 여행요금안내 -->
        <div v-if="statusData.activeTab === 'fare'" class="hp_tabWrap_priceWrap">
          <div v-if="statusData.clickDate === ''" class="priceWrap_offPrice">
            <p>달력에서 날짜를 선택하면 여행 요금을 확인할 수 있습니다.</p>
          </div>
          <div v-else>
            <div v-if="statusData.clickScheduleOptionUseStatus === 1" class="priceWrap_onPrice">
              <div class="priceWrap_onPriceTit">가격정보<span>{{ statusData.clickDate }}</span></div>

              <!-- 그룹 옵션이 있는 경우 -->
              <div v-if="statusData.clickScheduleGroupOptionUseStatus === 1">
                <div v-for="groupOption in statusData.scheduleGroupOptionRows" :key="groupOption.schedule_group_option_ID">
                  <div v-for="option in filteredGroupOptionsByGroupOption(groupOption.schedule_group_option_ID)" :key="option.schedule_option_ID">
                    <table border="0" cellspacing="0" cellpadding="0" summary="가격정보" class="priceWrap_onPriceDetail">
                      <caption>가격정보</caption>
                      <colgroup>
                        <col width="22%">
                        <col width="22%">
                        <col width="27%">
                        <col width="27%">
                      </colgroup>
                      <thead>
                        <tr>
                          <th colspan="2" scope="col">구분</th> <!-- 구분-->
                          <!-- <th scope="col">{{ option.schedule_option_name }}</th> --> <!-- 옵션2 타이틀 -->
                          <th scope="col">대인</th>
                          <th scope="col">소인</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID">
                          <td style="color:#364da0;">{{ groupOption.schedule_group_option_name }}</td> <!-- 옵션1 값 -->
                          <td>{{ list.schedule_option_list_name }}</td> <!-- 옵션2 값 -->
                          <td>{{ list.schedule_option_list_price.toLocaleString() }}<span>원</span></td> <!-- 대인가격 -->
                          <td>{{ list.schedule_option_list_price_child.toLocaleString() }}<span>원</span></td> <!-- 소인가격 -->
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              <!-- 그룹 옵션이 없는 경우 -->
              <div v-else>
                <div v-for="option in statusData.scheduleOptionRows" :key="option.schedule_option_ID">
                  <table border="0" cellspacing="0" cellpadding="0" summary="가격정보" class="priceWrap_onPriceDetail">
                    <caption>가격정보</caption>
                    <colgroup>
                      <col width="33%">
                      <col width="33%">
                      <col width="33%">
                    </colgroup>
                    <thead>
                      <tr>
                        <th scope="col">{{ option.schedule_option_name }}</th>
                        <th scope="col">대인</th>
                        <th scope="col">소인</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="list in optionLists(option.schedule_option_ID)" :key="list.schedule_option_list_ID">
                        <td>{{ list.schedule_option_list_name }}</td> <!-- 옵션 -->
                        <td>{{ list.schedule_option_list_price.toLocaleString() }}<span>원</span></td> <!-- 대인가격 -->
                        <td>{{ list.schedule_option_list_price_child.toLocaleString() }}<span>원</span></td> <!-- 소인가격 -->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- 기본 -->
            <div v-if="statusData.clickScheduleOptionUseStatus === 2" class="priceWrap_onPrice">
              <div class="priceWrap_onPriceTit">가격정보<span>{{ statusData.clickDate }}</span></div>
              <table border="0" cellspacing="0" cellpadding="0" summary="가격정보" class="priceWrap_onPriceDetail">
                <caption>가격정보</caption>
                <colgroup>
                  <col width="50%">
                  <col width="50%">
                </colgroup>
                <thead>
                  <tr>
                    <th scope="col">대인</th>
                    <th scope="col">소인</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ statusData.scheduleSeats.schedule_price.toLocaleString() }}<span>원</span></td> <!-- 대인가격 -->
                    <td>{{ statusData.scheduleSeats.schedule_price_child.toLocaleString() }}<span>원</span></td> <!-- 소인가격 -->
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- 탭 : 이용안내 -->
        <div v-if="statusData.activeTab === 'guide'" class="hp_tabWrap_guideWrap">
          <div v-editor-html="statusData.travelProduct.travel_product_caution"></div>
        </div>

        <!-- 탭 : 취소환불 -->
        <div v-if="statusData.activeTab === 'refund'" class="hp_tabWrap_refundWrap">
          <div v-editor-html="statusData.travelProduct.travel_product_cancel_refund"></div>
        </div>
      </div>
    </div> <!-- 전체 product detail wrap -->

    <!-- 공유하기 팝업 -->
    <div v-if="statusData.isPopupVisible" class="hp_popupBg">
      <div class="hp_popupContentWrapSheare">
      <button class="hp_popupContentWrapSheareClose" @click="togglePopup">Close</button>
        <div class="hp_popupContentBox">
          <h2>SNS 공유하기</h2>
          <div class="hp_popupContentWrapSheareIcon">
            <button @click="shareToFacebook">
              <p><img src="../../../assets/images/icon/ico_facebook.png" alt="Facebook" /></p>
              페이스북
            </button>
            <button @click="shareToTwitter">
              <p><img src="../../../assets/images/icon/ico_twitter.png" alt="Twitter" /></p>
              트위터
            </button>
            <button @click="shareToBlog">
              <p><img src="../../../assets/images/icon/ico_blog.png" alt="Blog" /></p>
              블로그
            </button>
            <button @click="shareToKakao">
              <p><img src="../../../assets/images/icon/ico_kakao.png" alt="KakaoTalk" /></p>
              카카오톡
            </button>
            <button @click="copyUrl">
              <p><img src="../../../assets/images/icon/ico_url.png" alt="URL Copy" /></p>
              URL복사
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer/>
  </div>
</template>

<!-- eslint-disable camelcase -->
<script>
import { ref, computed } from 'vue'
import Header from '../Section/Header.vue'
import Footer from '../Section/Footer.vue'
import Scroll from '../Section/Scroll.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import dayjs from 'dayjs'
import {
  get_travel_product_one,
  get_schedule_day,
  get_schedule_seats,
  get_schedule_option_seats,
  check_schedule_day,
  get_session_customer,
  insert_interest_travel
} from '../../ETC/Axios.vue'

export default {
  name: 'TravelProductDetail',
  components: {
    Header,
    Footer,
    Scroll,
    Swiper,
    SwiperSlide
  },
  setup () {
    const sessionData = ref({
      customer: ''
    })
    const statusData = ref({
      travelProductID: '',
      travelProduct: [],
      travelScheduleTimes: [],
      travelScheduleDetailTimes: [],
      scheduleSeats: [],
      scheduleGroupOptionRows: [],
      scheduleOptionRows: [],
      scheduleOptionListRows: [],
      clickScheduleOptionUseStatus: 0,
      clickScheduleGroupOptionUseStatus: 0,
      clickScheduleGroupOptionTitle: '',
      scheduleID: '',
      totalSeats: 0,
      selectedAdults: 0,
      selectedChildren: 0,
      totalPrice: 0,
      selectedGroupOption: 0,
      selectedOptionList: 0,
      groups: [],
      editorData1: [],
      editorData2: [],
      travelImages: [],
      travelProductSwiperOptions: {
        autoplay: {
          delay: 2000,
          disableOnInteraction: false
        },
        speed: 1200,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true, /* 무한 루프 */
        loopAdditionalSlides: 12, /* 무한 루프 첫번째 순서를 위해 슬라드 수 임의로 10으로 작성 */
        navigation: {
          prevEl: '.travel_product_detail_swiper_prev',
          nextEl: '.travel_product_detail_swiper_next'
        }
      },
      currentDate: dayjs().startOf('month').toDate(),
      nextDate: dayjs().startOf('month').add(1, 'month').endOf('month').toDate(),
      dayNames: ['일', '월', '화', '수', '목', '금', '토'],
      calendarData: {},
      isPrevDisabled: true,
      activeTab: 'itinerary',
      isMobile: computed(() => {
        return window.innerWidth <= 768
      }),
      clickDate: '',
      isPopupVisible: false
    })
    return { sessionData, statusData }
  },
  methods: {
    handlePrint () {
      window.print()
    },
    togglePopup () {
      this.statusData.isPopupVisible = !this.statusData.isPopupVisible
    },
    shareToFacebook () {
      const url = window.location.href
      window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`, '_blank')
    },
    shareToTwitter () {
      const url = window.location.href
      const text = encodeURIComponent(this.statusData.travelProduct.travel_product_name)
      window.open(`https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${text}`, '_blank')
    },
    shareToBlog () {
      const url = window.location.href
      const title = encodeURIComponent(this.statusData.travelProduct.travel_product_name)
      window.open(`https://share.naver.com/web/shareView.nhn?url=${encodeURIComponent(url)}&title=${title}`, '_blank')
    },
    shareToKakao () {
      // eslint-disable-next-line no-undef
      if (!Kakao.isInitialized()) {
        alert('카카오 SDK가 초기화되지 않았습니다.')
        return
      }

      // eslint-disable-next-line no-undef
      Kakao.Link.sendDefault({
        objectType: 'feed',
        content: {
          title: this.statusData.travelProduct.travel_product_name,
          description: '여행 상품의 자세한 정보를 확인하세요!',
          imageUrl: this.statusData.travelImages[0],
          link: {
            webUrl: window.location.href,
            mobileWebUrl: window.location.href
          }
        },
        buttons: [
          {
            title: '자세히 보기',
            link: {
              webUrl: window.location.href,
              mobileWebUrl: window.location.href
            }
          }
        ]
      })
    },

    copyUrl () {
      navigator.clipboard.writeText(window.location.href).then(() => {
        alert('주소가 복사되었습니다. 원하시는 곳에 붙여넣기 할 수 있습니다.')
      })
    },
    loadSchedule (travelProductID, currentDate) {
      get_schedule_day(
        travelProductID,
        dayjs(new Date(currentDate)).format('YYYY-MM-DD'),
        dayjs(dayjs(currentDate).add(1, 'month').endOf('month').toDate()).format('YYYY-MM-DD')
      ).then(result => {
        this.statusData.calendarData = {}
        result.forEach(schedule => {
          const remainingSeats = schedule.total_schedule_seats - schedule.total_reservation_number_count - schedule.total_reservation_number_count_child
          const isPast = dayjs(schedule.schedule_start_day).isBefore(dayjs(), 'day')

          let status = ''
          let detail = ''
          let colorClassName = ''

          if (isPast) {
            status = '날짜지남'
            detail = '예약마감'
            colorClassName = 'has-gray'
          } else if (remainingSeats === 0) {
            status = '여유:0명'
            detail = '예약마감'
            colorClassName = 'has-gray'
          } else if (
            schedule.total_reservation_number_count + schedule.total_reservation_number_count_child >=
            this.statusData.travelProduct.travel_product_minimum_departure
          ) {
            status = `여유:${remainingSeats}명`
            detail = '출발확정'
            colorClassName = 'has-red'
          } else {
            status = `여유:${remainingSeats}명`
            detail = '예약가능'
            colorClassName = 'has-blue'
          }

          this.statusData.calendarData[schedule.schedule_start_day] = {
            schedule_ID: schedule.schedule_ID,
            total_schedule_seats: remainingSeats,
            schedule_option_use_status: schedule.schedule_option_use_status,
            schedule_group_option_status: schedule.schedule_group_option_status,
            schedule_group_option_title: schedule.schedule_group_option_title,
            schedule_start_day: schedule.schedule_start_day,
            status,
            detail,
            color_class_name: colorClassName
          }
        })
      })
    },
    formatDate (date, format) {
      return dayjs(date).format(format)
    },
    getCalendarDates (date) {
      const startDay = dayjs(date).startOf('month').day()
      const daysInMonth = dayjs(date).daysInMonth()
      const dates = []
      for (let i = 0; i < startDay; i++) {
        dates.push({ day: '', info: null })
      }
      for (let i = 1; i <= daysInMonth; i++) {
        const currentDate = dayjs(date).date(i).format('YYYY-MM-DD')
        dates.push({
          day: i,
          info: this.statusData.calendarData[currentDate] || null
        })
      }
      return dates
    },
    handleDateClick (date) {
      if (!date.day) return

      const today = dayjs().format('YYYY-MM-DD')
      const selectedDate = dayjs(date.info.schedule_start_day).format('YYYY-MM-DD')

      if (date.info === null) {
        alert(`해당날짜에 스케줄이 없습니다.`)
      } else if (dayjs(selectedDate).isBefore(today)) {
        alert('예약이 마감되었습니다.')
      } else if (date.info.total_schedule_seats > 0) {
        this.statusData.scheduleID = date.info.schedule_ID
        this.statusData.clickScheduleOptionUseStatus = date.info.schedule_option_use_status
        this.statusData.clickScheduleGroupOptionUseStatus = date.info.schedule_group_option_status
        this.statusData.clickScheduleGroupOptionTitle = date.info.schedule_group_option_title

        if (date.info.schedule_option_use_status === 1) {
          get_schedule_option_seats(date.info.schedule_ID).then(result_data => {
            if (date.info.schedule_group_option_status === 0) {
              result_data.schedule_option_rows = result_data.schedule_option_rows.filter(
                option => option.schedule_group_option_ID_use_schedule_option === 0
              )
              this.statusData.scheduleGroupOptionRows = []
            } else {
              result_data.schedule_option_rows = result_data.schedule_option_rows.filter(
                option => option.schedule_group_option_ID_use_schedule_option !== 0
              )
              this.statusData.scheduleGroupOptionRows = result_data.schedule_group_option_rows
            }
            this.statusData.scheduleOptionRows = result_data.schedule_option_rows
            this.statusData.scheduleOptionListRows = result_data.schedule_option_list_rows
            const totalSeats = result_data.schedule_option_list_rows.reduce((total, option) => total + option.schedule_option_list_seats - option.reservation_number_count - option.reservation_number_count_child, 0)
            const reserSeats = result_data.schedule_option_list_rows.reduce((total, option) => total + option.reservation_number_count + option.reservation_number_count_child, 0)
            date.info.total_schedule_seats = totalSeats
            date.info.status = `여유:${totalSeats}명`
            if (totalSeats === 0) {
              date.info.detail = '예약마감'
              date.info.color_class_name = 'has-gray'
              alert(`예약이 마감되었습니다.`)
            } else if (reserSeats >= this.statusData.travelProduct.travel_product_minimum_departure) {
              date.info.detail = '출발확정'
              date.info.color_class_name = 'has-red'
            } else {
              date.info.detail = '예약가능'
              date.info.color_class_name = 'has-blue'
            }
            this.statusData.clickDate = date.info.schedule_start_day
            this.statusData.groups = []
            this.addGroup()
            this.$forceUpdate()
          })
        } else {
          get_schedule_seats(date.info.schedule_ID).then(result_data => {
            const totalSeats = result_data.reduce((total, option) => total + option.schedule_seats - option.reservation_number_count - option.reservation_number_count_child, 0)
            const reserSeats = result_data.reduce((total, option) => total + option.reservation_number_count + option.reservation_number_count_child, 0)
            this.statusData.totalSeats = totalSeats
            date.info.total_schedule_seats = totalSeats
            date.info.status = `여유:${totalSeats}명`
            if (totalSeats === 0) {
              date.info.detail = '예약마감'
              date.info.color_class_name = 'has-gray'
              alert(`예약이 마감되었습니다.`)
            } else if (reserSeats >= this.statusData.travelProduct.travel_product_minimum_departure) {
              date.info.detail = '출발확정'
              date.info.color_class_name = 'has-red'
              this.statusData.scheduleSeats = result_data[0]
              this.statusData.clickDate = date.info.schedule_start_day
            } else {
              date.info.detail = '예약가능'
              date.info.color_class_name = 'has-blue'
              this.statusData.scheduleSeats = result_data[0]
              this.statusData.clickDate = date.info.schedule_start_day
            }
            this.$forceUpdate()
          })
        }
      } else if (date.info.total_schedule_seats === 0) {
        alert(`예약이 마감되었습니다.`)
      }
    },
    prevMonth () {
      this.statusData.currentDate = dayjs(this.statusData.currentDate).subtract(1, 'month').startOf('month').toDate()
      this.statusData.nextDate = dayjs(this.statusData.currentDate).add(1, 'month').endOf('month').toDate()
      this.statusData.isPrevDisabled = false
      this.loadSchedule(this.statusData.travelProductID, this.statusData.currentDate)
    },
    nextMonth () {
      this.statusData.currentDate = dayjs(this.statusData.currentDate).add(1, 'month').startOf('month').toDate()
      this.statusData.nextDate = dayjs(this.statusData.currentDate).add(1, 'month').endOf('month').toDate()
      this.statusData.isPrevDisabled = dayjs().isAfter(dayjs(this.statusData.currentDate), 'month')
      this.loadSchedule(this.statusData.travelProductID, this.statusData.currentDate)
    },
    toggleVisibility (detail) {
      detail.isVisible = !detail.isVisible
    },
    updateSelection (type) {
      if (type === 'adults') {
        this.statusData.selectedChildren = Math.min(this.statusData.selectedChildren, this.statusData.totalSeats - this.statusData.selectedAdults)
      } else if (type === 'children') {
        if (this.statusData.selectedAdults === 0 && this.statusData.selectedChildren > 0) {
          alert('먼저 대인을 선택해주세요.')
          this.statusData.selectedChildren = 0
        } else {
          this.statusData.selectedAdults = Math.min(this.statusData.selectedAdults, this.statusData.totalSeats - this.statusData.selectedChildren)
        }
      }
      this.calculateTotalPrice()
    },
    calculateTotalPrice () {
      this.statusData.totalPrice = (this.statusData.selectedAdults * this.statusData.scheduleSeats.schedule_price) + (this.statusData.selectedChildren * this.statusData.scheduleSeats.schedule_price_child)
    },
    optionLists (optionId) {
      return this.statusData.scheduleOptionListRows.filter(list => list.schedule_option_ID_use_schedule_option_list === optionId)
    },
    updateSelectionOption (type, group, optionListId) {
      const selectedOptionList = this.statusData.scheduleOptionListRows.find(
        list => list.schedule_option_list_ID === optionListId
      )

      if (!selectedOptionList) return

      group.selectedOptionDetails = selectedOptionList

      if (type === 'adults') {
        group.selectedAdults = Math.min(
          group.selectedAdults,
          selectedOptionList.schedule_option_list_seats -
        selectedOptionList.reservation_number_count -
        selectedOptionList.reservation_number_count_child
        )
      } else if (type === 'children') {
        if (group.selectedAdults === 0 && group.selectedChildren > 0) {
          alert('먼저 대인을 선택해주세요.')
          group.selectedChildren = 0
        } else {
          group.selectedChildren = Math.min(
            group.selectedChildren,
            selectedOptionList.schedule_option_list_seats -
          selectedOptionList.reservation_number_count -
          selectedOptionList.reservation_number_count_child -
          group.selectedAdults
          )
        }
      }

      const totalSelected = group.selectedAdults + group.selectedChildren
      if (
        totalSelected % group.selectedOptionDetails.schedule_option_list_seats_max !== 0
      ) {
        this.$set(group, 'totalPriceValid', false)
      } else {
        this.$set(group, 'totalPriceValid', true)
      }

      this.checkTotalSeats(group)
    },
    checkTotalSeats (group) {
      const optionListSeats = {}

      this.statusData.groups.forEach(g => {
        if (g.selectedOptionList) {
          if (!optionListSeats[g.selectedOptionList]) {
            optionListSeats[g.selectedOptionList] = {
              selectedSeats: 0,
              availableSeats: 0
            }
          }
          optionListSeats[g.selectedOptionList].selectedSeats += g.selectedAdults + g.selectedChildren
          const selectedOptionList = this.statusData.scheduleOptionListRows.find(
            list => list.schedule_option_list_ID === g.selectedOptionList
          )
          if (selectedOptionList) {
            optionListSeats[g.selectedOptionList].availableSeats = selectedOptionList.schedule_option_list_seats - selectedOptionList.reservation_number_count - selectedOptionList.reservation_number_count_child
          }
        }
      })

      const currentOptionListSeats = optionListSeats[group.selectedOptionList]

      if (currentOptionListSeats.selectedSeats > currentOptionListSeats.availableSeats) {
        this.$set(group, 'totalPriceValid', false)
        alert('예약 가능한 좌석 수를 초과했습니다.')
      }

      this.$forceUpdate()
    },
    filteredGroupOptions (group) {
      if (!group.selectedGroupOption) return []
      return this.statusData.scheduleOptionRows.filter(
        option => option.schedule_group_option_ID_use_schedule_option === group.selectedGroupOption
      )
    },
    availableSeats (listId) {
      const list = this.statusData.scheduleOptionListRows.find(list => list.schedule_option_list_ID === listId)
      if (!list) {
        return 0
      }
      const available = list.schedule_option_list_seats - list.reservation_number_count - list.reservation_number_count_child
      return available
    },
    availableAdultSeats (availableSeats) {
      const seats = availableSeats || 0
      return Array.from({ length: seats }, (_, i) => i + 1)
    },
    availableChildSeats (availableSeats, selectedAdults) {
      const seats = (availableSeats || 0) - (selectedAdults || 0)
      return Array.from({ length: seats }, (_, i) => i + 1)
    },
    totalPriceGroup (group) {
      if (!group.selectedOptionDetails) return 0
      const adultsPrice = group.selectedAdults * (group.selectedOptionDetails.schedule_option_list_price || 0)
      const childrenPrice = group.selectedChildren * (group.selectedOptionDetails.schedule_option_list_price_child || 0)
      return adultsPrice + childrenPrice
    },
    totalGroupPrice () {
      const allValid = this.statusData.groups.every((group) => group.totalPriceValid)
      if (!allValid) return '인원을 맞춰주세요'

      const totalPrice = this.statusData.groups.reduce((total, group) => {
        return total + this.totalPriceGroup(group)
      }, 0)
      return `${totalPrice.toLocaleString()}원`
    },
    addGroup () {
      this.statusData.groups.push({
        selectedGroupOption: 0,
        selectedOptionList: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        availableSeats: 0,
        selectedOptionDetails: {},
        totalPriceValid: true
      })
    },
    addGroupWithoutOption () {
      this.statusData.groups.push({
        selectedOptionList: 0,
        selectedAdults: 0,
        selectedChildren: 0,
        availableSeats: 0,
        selectedOptionDetails: {},
        totalPriceValid: true
      })
    },
    updateSelectedOptionDetails (group) {
      const selectedOption = this.statusData.scheduleOptionListRows.find(
        option => option.schedule_option_list_ID === group.selectedOptionList
      )
      group.selectedAdults = 0
      group.selectedChildren = 0
      if (selectedOption) {
        group.selectedOptionDetails = selectedOption
        group.availableSeats = this.availableSeats(group.selectedOptionList)
      } else {
        group.selectedOptionDetails = null
        group.availableSeats = 0
      }
    },
    removeGroup (index) {
      if (this.statusData.groups.length > 0) {
        this.statusData.groups.pop()
      }
    },
    resetOptions (group) {
      group.selectedOptionList = 0
      group.selectedAdults = 0
      group.selectedChildren = 0
    },
    handleReservation () {
      if (this.statusData.clickScheduleOptionUseStatus === 2) {
        if (this.statusData.selectedAdults === 0) {
          alert('대인은 필수로 선택해주세요.')
          return
        }
        if (!this.statusData.totalPrice) {
          alert('올바른 총 가격을 입력해주세요.')
          return
        }
      }

      if (this.statusData.clickScheduleOptionUseStatus === 1) {
        for (let group of this.statusData.groups) {
          if (group.selectedAdults === 0) {
            alert('대인은 필수로 선택해주세요.')
            return
          }
          if (!group.totalPriceValid) {
            alert('옵션별로 올바른 총 가격을 입력해주세요.')
            return
          }
        }
      }

      const route = this.sessionData.customer === '' ? '/ReservationLogin' : '/Reservation'
      const data = {
        scheduleID: this.statusData.scheduleID,
        scheduleOptionUseStatus: this.statusData.clickScheduleOptionUseStatus,
        scheduleGroupOptionUseStatus: this.statusData.clickScheduleGroupOptionUseStatus,
        selectedAdults: this.statusData.selectedAdults,
        selectedChildren: this.statusData.selectedChildren,
        groups: this.statusData.groups
      }
      localStorage.setItem('reservationData', JSON.stringify(data))
      this.$router.push({ path: route })
    },
    filteredGroupOptionsByGroupOption (groupOptionID) {
      return this.statusData.scheduleOptionRows.filter(
        option => option.schedule_group_option_ID_use_schedule_option === groupOptionID
      )
    },
    handleWishlist () {
      if (this.sessionData.customer === '') {
        alert('로그인 회원 서비스입니다. 로그인하시면 이용하실 수 있습니다.')
      } else {
        insert_interest_travel(
          this.statusData.travelProduct.travel_product_ID,
          this.sessionData.customer.customer_ID
        ).then(result => {
          if (confirm('관심여행이 저장되었습니다. 나의 관심여행으로 이동하시겠습니까?')) {
            this.$router.push({
              path: '/My',
              query: {
                myID: 3
              }
            })
          }
        })
      }
    }
  },
  mounted () {
    // eslint-disable-next-line no-undef
    Kakao.init('cd8491011402758f6ef9a9448a5e934c')
    this.statusData.travelProductID = this.$route.query.travelProductID
    get_travel_product_one(this.statusData.travelProductID).then(result_data => {
      this.statusData.travelProduct = result_data.travel_product[0]
      this.statusData.travelScheduleTimes = result_data.schedule_time_rows
      this.statusData.travelScheduleDetailTimes = result_data.schedule_detail_time_rows
      this.statusData.editorData1 = result_data.editor_row1[0]
      this.statusData.editorData2 = result_data.editor_row2[0]

      this.statusData.travelImages = [
        result_data.travel_product[0].travel_product_img1,
        result_data.travel_product[0].travel_product_img2,
        result_data.travel_product[0].travel_product_img3,
        result_data.travel_product[0].travel_product_img4,
        result_data.travel_product[0].travel_product_img5,
        result_data.travel_product[0].travel_product_img6,
        result_data.travel_product[0].travel_product_img7,
        result_data.travel_product[0].travel_product_img8,
        result_data.travel_product[0].travel_product_img9,
        result_data.travel_product[0].travel_product_img10
      ].filter(img => img)
      check_schedule_day(
        this.statusData.travelProductID
      ).then(result => {
        if (result[0].schedule_start_day !== '') {
          const firstDayOfMonth = dayjs(result[0].schedule_start_day).startOf('month').toDate()
          this.statusData.currentDate = firstDayOfMonth
          this.statusData.nextDate = dayjs(firstDayOfMonth).add(1, 'month').endOf('month').toDate()
        }
        this.loadSchedule(
          this.statusData.travelProductID,
          this.statusData.currentDate
        )
      })
    })
    get_session_customer().then(result => {
      this.sessionData.customer = result
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Travel/TravelProductDetail.vue